module.exports = __webpack_public_path__ + "static/media/mogulreiti.41ec9511.m4v";